// state
export const state = {
  collectionsData: []
}

// getters
export const getters = {
  collectionsData: state => state.collectionsData
}

// mutation
export const mutations = {
  // [types.FETCH_TAGS_SUCCESS] (state, { tags, myTagsTotal }) {
  //   state.tags = tags
  //   state.myTagsTotal = myTagsTotal
  // }
  CLEAR_COLLECTIONS_DATA (state) {
    state.collectionsData = []
  }
}

// actions
export const actions = {
  // async fetchPopularTags ({ commit }) {
  //   const { data } = await tagsServices.fetchPopularTags()
  //   try {
  //     commit(types.SET_TAGS_POPULAR_TAGS, {
  //       popularTags: data
  //     })
  //   } catch (error) {
  //     console.log(error)
  //   }
  // },
  async clearCollectionsData ({ commit }) {
    commit('CLEAR_COLLECTIONS_DATA')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
